import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import axios from 'axios';
import './App.css';
const QrScanner = () => {
  const scannerId = "qr-reader";
  const [scanResult, setScanResult] = useState("");
  const [error, setError] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const html5QrCodeRef = useRef(null);

  const beepSound = new Audio("notification-20-270145.mp3"); // Beep sound URL
  const [scannerlist, setscannerlist] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // Start live camera scanner on mount
  useEffect(() => {
    const html5QrCode = new Html5Qrcode(scannerId);
    html5QrCodeRef.current = html5QrCode;

    html5QrCode
      .start(
        { facingMode: "environment" }, // back camera
        { fps: 10, qrbox: 250 },
        (decodedText) => {
          setScanResult(decodedText);
          beepSound.play(); // Play beep sound when QR code is scanned
          stopScanner(); // stop after first scan
        },
        (errorMessage) => {
          console.log("Scan error:", errorMessage);
          setError("No QR code found. Try again.");
        }
      )
      .then(() => setIsScanning(true))
      .catch((err) => {
        console.error("Start error:", err);
        setError("Camera permission denied or not available.");
      });

    return () => stopScanner(); // cleanup on unmount
  }, []);


  useEffect(() => {
    scannerticket();
}, [scanResult]);


const handleSubmit = async(e) => {
    e.preventDefault(); // prevent page refresh
    console.log("Submitted Value:", inputValue);

        try {
    
          const response = await axios.get('https://robotecheducation.com/api/ticket_scanner/'+inputValue);
          if (response.data.status == 'success') {
    
            setscannerlist(response.data.scan_list);
          }else{
            alert('No data found');
          }
        } catch (error) {
    
        }
      
  };


  const scannerticket = async () => {
    try {

      const response = await axios.get('https://robotecheducation.com/api/ticket_scanner/'+scanResult);
      if (response.data.status == 'success') {

        setscannerlist(response.data.scan_list);
      }else{
        alert('No data found');
      }
    } catch (error) {

    }
  }
  const stopScanner = () => {
    if (html5QrCodeRef.current && isScanning) {
      html5QrCodeRef.current
        .stop()
        .then(() => {
          html5QrCodeRef.current.clear();
          setIsScanning(false);
        })
        .catch((err) => {
          console.error("Stop error:", err);
        });
    }
  };

  const scanFromFile = (e) => {
    const file = e.target.files[0];
    const html5QrCode = new Html5Qrcode("qr-reader");

    html5QrCode
      .scanFile(file, true)
      .then((text) => {
        setScanResult(text);
     
        beepSound.play(); // Play beep sound when QR code is scanned
        setError("");
      })
      .catch((err) => {
        console.error("File scan error:", err);
        setError("Failed to scan from image.");
      });
  };

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h2>Robotech Ticket Scanner</h2>
        <div style={{ height: "400px",marginBottom:'10%'}}>
      <div
        id={scannerId}
        style={{
          width: "300px",
          height: "300px",
          margin: "0 auto",
          border: "1px solid #ccc",
        }}
      />
</div>
     


      <hr style={{ margin: "30px 0" }} />

      <h4>Scan QR from Image</h4>
      <input type="file" accept="image/*" onChange={scanFromFile} />
      <div style={{ textAlign: "center", marginTop: "50px" }}>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Type something..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          style={{ padding: "10px", width: "200px", marginRight: "10px" }}
        />
        <button type="submit" style={{ padding: "10px 20px" }}>
          Check Ticket
        </button>
      </form>
    </div>
      <div style={{ marginTop: "20px" }}>
        <strong>Scanned Result:</strong>
        <p>{scanResult || "Waiting for QR code..."}</p>
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>   
<table>
  <tr>
    <th>S.No</th>
    <th>Date Time</th>
  </tr>
 
      {scannerlist.map((data, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td> <p style={{color:'red'}}>{data.scan_time}</p></td>
          </tr>
          ))}
        
    
</table>
</div>
    </div>
  );
};

export default QrScanner;
